import React, { createContext, useState, useContext } from "react";

const MessageSearchContext = createContext();

export const MessageSearchProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [currentResultIndex, setCurrentResultIndex] = useState(-1);
  const [highlightMessageId, setHighlightMessageId] = useState(null);

  const clearSearch = () => {
    setSearchTerm("");
    setSearchResults([]);
    setCurrentResultIndex(-1);
    setHighlightMessageId(null);
  };

  const goToNextResult = () => {
    if (searchResults.length === 0) return;
    const nextIndex = (currentResultIndex + 1) % searchResults.length;
    setCurrentResultIndex(nextIndex);
    setHighlightMessageId(searchResults[nextIndex]);
  };

  const goToPreviousResult = () => {
    if (searchResults.length === 0) return;
    const prevIndex =
      currentResultIndex - 1 < 0
        ? searchResults.length - 1
        : currentResultIndex - 1;
    setCurrentResultIndex(prevIndex);
    setHighlightMessageId(searchResults[prevIndex]);
  };

  return (
    <MessageSearchContext.Provider
      value={{
        searchTerm,
        setSearchTerm,
        searchResults,
        setSearchResults,
        currentResultIndex,
        setCurrentResultIndex,
        highlightMessageId,
        setHighlightMessageId,
        clearSearch,
        goToNextResult,
        goToPreviousResult,
      }}
    >
      {children}
    </MessageSearchContext.Provider>
  );
};

export const useMessageSearch = () => {
  const context = useContext(MessageSearchContext);
  if (!context) {
    throw new Error(
      "useMessageSearch must be used within a MessageSearchProvider"
    );
  }
  return context;
};

